import React from 'react'
import Layout from '../../components/Layout'

const ColorsPage = () => {
    return (
        <React.Fragment>
            ColorsPage
        </React.Fragment>
    )
}

export default ColorsPage
